import { Modal } from 'antd';
import React from 'react';
import { Document, Page } from 'react-pdf';
import { Spinner } from '../../components/loading/Spinner';
import { ModalTitle } from '../../components/text/Titles';
import { Entity } from '../../types';
import { FailedToLoadPage } from './components';

type Props = {
  file: any;
  detailEntity: { entity: Entity; index: number };
  onCancel: () => void;
  onDocumentLoadSuccess: any;
};

export const EntityDetailView = ({ file, detailEntity, onCancel, onDocumentLoadSuccess }: Props) => {
  return (
    <Modal
      width={1000}
      style={{ top: '50px' }}
      visible={detailEntity.entity !== null}
      title={<ModalTitle>Document {detailEntity.index}</ModalTitle>}
      onCancel={onCancel}
      footer={null}>
      <div style={{ paddingTop: '2em', paddingBottom: '0em', background: '#f0f2f5', minHeight: '500px' }}>
        <Document
          className="pointer-events-none"
          loading={<Spinner />}
          file={file}
          onLoadSuccess={() => onDocumentLoadSuccess}>
          {new Array(detailEntity.entity.length)
            .fill(detailEntity.entity.start_page)
            .map((index, i) => index + i)
            .map(index => {
              return (
                <div
                  key={index}
                  className="flex justify-center items-center relative pb-8 mb-8"
                  style={{
                    borderBottom:
                      index !== detailEntity.entity.start_page + detailEntity.entity.length - 1 ? '1px solid #ccc' : '',
                  }}>
                  <div style={{ position: 'absolute', left: '1em', top: '1em', fontSize: '20px', fontWeight: 'bold' }}>
                    Page {index}
                  </div>
                  <Page
                    key={index}
                    width={700}
                    pageNumber={index}
                    error={<FailedToLoadPage height={300} width={700} />}
                  />
                </div>
              );
            })}
        </Document>
      </div>
    </Modal>
  );
};
